import styled from 'styled-components';

import { theme } from '../layout/theme';

interface ISkeleton {
  height?: string;
  width?: string;
  mobilePadding?: string;
  desktopPadding?: string;
}

export const Skeleton = styled.div<ISkeleton>`
  background: ${theme.colors.bg.accent};
  padding-bottom: ${({ mobilePadding }) => mobilePadding};

  ${theme.screens.Md} {
    padding-bottom: ${({ desktopPadding }) => desktopPadding};
  }
`;
